
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Calendar } from '../ui/calendar';
import { isDateDisabled } from '../../utils/timeSlotUtils';
import { Doctor } from '../../types';
import { addDays } from 'date-fns';

interface DateSelectorProps {
  selectedDate: Date | null;
  doctor: Doctor | null;
  onDateSelect: (date: Date | undefined) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({ 
  selectedDate, 
  doctor, 
  onDateSelect 
}) => {
  // Set disabled dates (past dates and doctor's off days)
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Allow selection for next 30 days only
  const thirtyDaysFromNow = addDays(today, 30);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg text-teal-700">Select Date</CardTitle>
      </CardHeader>
      <CardContent>
        <Calendar
          mode="single"
          selected={selectedDate || undefined}
          onSelect={onDateSelect}
          disabled={(date) => isDateDisabled(date, doctor)}
          className="rounded-md border shadow-md mx-auto pointer-events-auto"
          fromDate={today}
          toDate={thirtyDaysFromNow}
        />
      </CardContent>
    </Card>
  );
};

export default DateSelector;
